/* =============================================
   JWW STACK FINDER POPUP
   Triggers: 4s idle OR 50% scroll depth
   ============================================= */

(function () {
  'use strict';

  var STORAGE_KEY = 'jww_popup_seen';
  var DELAY_MS    = 11000;
  var SCROLL_PCT  = 50;

  function alreadySeen() {
  try {
    var ts = localStorage.getItem(STORAGE_KEY);
    if (!ts) return false;
    return (Date.now() - parseInt(ts, 10)) < 24 * 60 * 60 * 1000;
  } catch(e) { return false; }
 }

  function markSeen() {
  try { localStorage.setItem(STORAGE_KEY, Date.now().toString()); } catch(e) {}
 }

  function onCurrentPage() {
    return window.location.pathname.indexOf('find-your-stack') !== -1;
  }

  function init() {
    if (alreadySeen() || onCurrentPage()) return;

    /* ---- BUILD HTML ---- */
    var overlay = document.createElement('div');
    overlay.id = 'jww-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Find Your Stack');

    overlay.innerHTML = [
      '<div id="jww-popup">',
        '<button id="jww-popup-close" aria-label="Close popup">&#x2715;</button>',

        '<div class="jww-left">',
          '<div class="jww-eyebrow">',
            '<div class="jww-pulse"></div>',
            'Find Your Stack',
          '</div>',
          '<h2>Supplements<br>should fit<br>your <em>biology.</em></h2>',
          '<div class="jww-subtext">',
            'Answer 8 quick questions and we\'ll recommend the exact stack your body actually needs &mdash; no overlapping ingredients, no unnecessary products.',
          '</div>',
          '<div class="jww-pills">',
            '<div class="jww-pill"><span style="color:var(--jww-teal)">&#x23F1;</span> Under 90 seconds</div>',
            '<div class="jww-pill"><span style="color:var(--jww-teal)">&#x2713;</span> No random stacking</div>',
            '<div class="jww-pill"><span style="color:var(--jww-teal)">&#x2713;</span> Personalized for you</div>',
          '</div>',
          '<div class="jww-btns">',
            '<a href="https://justwhatworks.in/pages/find-your-stack" class="jww-btn-primary">',
              'Find My Stack <span class="jww-arrow">&#x2192;</span>',
            '</a>',
            '<a href="https://justwhatworks.in/collections" class="jww-btn-ghost">Explore Products</a>',
          '</div>',
        '</div>',

        '<div class="jww-right">',
          '<div class="jww-right-label">How It Works</div>',
          '<div class="jww-steps">',
            '<div class="jww-step">',
              '<div class="jww-step-num">Step 1</div>',
              '<h3>Tell us what you\'re feeling</h3>',
              '<p>Low energy, poor sleep, stress, brain fog &mdash; we map the patterns behind your symptoms.</p>',
            '</div>',
            '<div class="jww-step">',
              '<div class="jww-step-num">Step 2</div>',
              '<h3>We identify what\'s needed</h3>',
              '<p>We match your answers to the exact biological pathways that need support.</p>',
            '</div>',
            '<div class="jww-step">',
              '<div class="jww-step-num">Step 3</div>',
              '<h3>Get your personalized stack</h3>',
              '<p>A targeted, minimal recommendation built for focus, calm, sleep, and recovery.</p>',
            '</div>',
          '</div>',
        '</div>',

      '</div>'
    ].join('');

    document.body.appendChild(overlay);

    /* ---- SHOW / HIDE ---- */
    var shown = false;

    function showPopup() {
      if (shown) return;
      shown = true;
      clearTimeout(timerID);
      window.removeEventListener('scroll', onScroll);
      markSeen();
      /* double rAF ensures transition fires after display */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.classList.add('jww-visible');
        });
      });
    }

    function hidePopup() {
      overlay.classList.remove('jww-visible');
      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 480);
    }

    /* ---- TRIGGERS ---- */
    var timerID = setTimeout(showPopup, DELAY_MS);

    function onScroll() {
      var scrolled = window.scrollY + window.innerHeight;
      var total    = document.documentElement.scrollHeight;
      if ((scrolled / total) * 100 >= SCROLL_PCT) showPopup();
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ---- CLOSE ---- */
    document.getElementById('jww-popup-close').addEventListener('click', hidePopup);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) hidePopup();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hidePopup();
    });

    overlay.querySelector('.jww-btn-primary').addEventListener('click', function () {
      markSeen();
    });

    overlay.querySelector('.jww-btn-ghost').addEventListener('click', function () {
      hidePopup();
    });
  }

  /* ---- WAIT FOR DOM ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();